import {inject} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {NGXLogger} from "ngx-logger";
import {BaseTinyService} from "./BaseTinyService";

export abstract class BaseService extends BaseTinyService {

  protected logger: NGXLogger = inject(NGXLogger);
  protected translate = inject(TranslateService);

  constructor() {
    super();
  }
}
